<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="7">
            <a-form-model-item label="订单编号" prop="user">
              <a-input v-model="formInline.orderNo" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="7">
            <a-form-model-item label="用户uid" prop="password">
              <a-input
                v-model="formInline.password"
                type="password"
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="7">
            <a-form-model-item label="收支类型" prop="store">
              <a-select
                default-value="lucy"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.store"
              >
                <a-select-option value="jack">全部</a-select-option>
                <a-select-option value="lucy">收入</a-select-option>
                <a-select-option value="disabled"> 支出 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="创建时间" prop="store">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <runningWaterContent
          ref="aaa"
          :formInline="formInline"
        ></runningWaterContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import runningWaterContent from "./runningWaterContent.vue";
export default {
  components: {
    runningWaterContent,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        beginTime: "",
        endTime: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getFinancialListData();
    },
    onChange(date, dateString) {
      console.log(dateString);
      this.formInline.beginTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/runningWater/runningWater.vue